import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { AuthActions } from '@lyceo/shared/auth/data-access';
import { PupilContext } from '../../pupil-context';
import { PupilContextActions } from './pupil-context.actions';

export const PUPIL_CONTEXT_FEATURE_KEY: string = 'pupilContext';

export interface PupilContextState {
  pupilContext: PupilContext | undefined;
}

export const initialPupilContextState: PupilContextState = {
  pupilContext: undefined,
};

const reducer: ActionReducer<PupilContextState, Action> = createReducer(
  initialPupilContextState,
  on(
    AuthActions.logoutSuccess,
    (): PupilContextState => initialPupilContextState,
  ),
  on(
    PupilContextActions.setPupilContext,
    (state, { pupilContext }): PupilContextState => ({
      ...state,
      pupilContext,
    }),
  ),
);

export function pupilContextReducer(
  state: PupilContextState | undefined,
  action: Action,
): PupilContextState {
  return reducer(state, action);
}
